var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20809_27053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.836 8.33306V11.2944C18.836 12.1111 18.172 12.7751 17.3553 12.7751H16.9522C16.3859 16.1309 13.4668 18.6978 9.95192 18.6978C9.62455 18.6978 9.35965 18.4329 9.35965 18.1055C9.35965 17.7781 9.62455 17.5132 9.95192 17.5132C13.2175 17.5132 15.8746 14.8561 15.8746 11.5905V8.03693C15.8746 4.77134 13.2175 2.11423 9.95192 2.11423C6.68634 2.11423 4.02922 4.77134 4.02922 8.03693V12.1828C4.02922 12.5102 3.76432 12.7751 3.43695 12.7751H2.54855C1.73186 12.7751 1.06787 12.1111 1.06787 11.2944V8.33306C1.06787 7.51638 1.73186 6.85239 2.54855 6.85239H2.95168C3.51793 3.49658 6.43705 0.929688 9.95192 0.929688C13.4668 0.929688 16.3859 3.49658 16.9522 6.85239H17.3553C18.172 6.85239 18.836 7.51638 18.836 8.33306ZM9.95192 3.29877C7.33934 3.29877 5.21376 5.42435 5.21376 8.03693V10.9983C5.21376 13.6109 7.33934 15.7364 9.95192 15.7364C12.5645 15.7364 14.6901 13.6109 14.6901 10.9983V8.03693C14.6901 5.42435 12.5645 3.29877 9.95192 3.29877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20809_27053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9526,
    height: 18.9526,
    fill: "white",
    transform: "translate(0.475586 0.335938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.6bec2c7cb34d36e28399b2e5e5cfd324.svg";
export { ForwardRef as ReactComponent };